import React from "react";
import Seo from "@/components/Seo";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="terms-page">
      <Seo
        title="Användarvillkor"
        description="Användarvillkor för Bygglovskompassen. Kostnadsfri tjänst som hjälper svenska medborgare att sammanställa bygglovsansökan. Ansvarsbegränsning, ditt ansvar, tvist och lag."
        path="/terms"
      />
      <h1 className="text-4xl font-semibold tracking-tight text-zinc-900 mb-2" style={{ fontFamily: "Outfit" }}>
        Användarvillkor
      </h1>
      <p className="text-sm text-zinc-500 mb-8">Senast uppdaterad: 4 juli 2026</p>

      <div className="prose prose-zinc max-w-none space-y-6 text-zinc-800">
        <section>
          <h2 className="text-xl font-semibold mt-8 mb-2">1. Om tjänsten</h2>
          <p>
            Bygglovskompassen ("vi", "oss", "tjänsten") tillhandahålls kostnadsfritt via
            <code className="mx-1 text-sm bg-zinc-100 px-1 rounded">bygglovkollen.se</code>
            till medborgare i Sverige som vill förenkla sin bygglovsansökan. Tjänsten
            är ett hjälpmedel som informerar och sammanställer handlingar. Vi är
            <b> inte</b> en myndighet och lämnar inga bindande beslut.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mt-8 mb-2">2. Kostnad</h2>
          <p>
            Tjänsten är helt kostnadsfri för privatpersoner. Det kan tillkomma
            kostnader hos din kommun (t.ex. avgift för bygglovsprövning enligt PBL 12 kap).
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mt-8 mb-2">3. Ansvarsbegränsning</h2>
          <p>
            Vi levererar tjänsten <b>"i befintligt skick"</b>. Vi garanterar inte att
            AI-rådgivningen, regelmotorns bedömningar eller sammanställda PDF:er är
            felfria. Beslut om bygglov, anmälningsplikt eller lovbefrielse fattas
            <b> alltid</b> av din kommun. Vi ansvarar inte för ekonomiska förluster,
            avslag, förseningar eller andra konsekvenser till följd av användning av
            tjänsten.
          </p>
          <p>
            Det åligger dig som användare att kontrollera all information mot
            kommunens gällande detaljplan och att vid tveksamhet konsultera en
            certifierad kontrollansvarig eller bygglovshandläggare.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mt-8 mb-2">4. Ditt ansvar</h2>
          <p>Du förbinder dig att:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Endast ange korrekta uppgifter om dig själv och din fastighet.</li>
            <li>Inte försöka kringgå tekniska säkerhetsåtgärder eller obehörigt komma åt andras ärenden.</li>
            <li>Inte ladda upp material som kränker upphovsrätt eller annan persons rättigheter.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mt-8 mb-2">5. Behandling av personuppgifter</h2>
          <p>
            Se vår separata <a href="/privacy" className="text-blue-700 underline">Integritetspolicy</a> för
            information om hur vi behandlar dina personuppgifter enligt GDPR.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mt-8 mb-2">6. Immateriella rättigheter</h2>
          <p>
            Innehåll och struktur i tjänsten (kod, design, texter, regelmotor) tillhör
            Bygglovskompassen. Du får fritt använda genererade PDF:er och sammanställningar
            för egna bygglovsärenden.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mt-8 mb-2">7. Ändringar</h2>
          <p>
            Vi kan uppdatera dessa villkor. Väsentliga ändringar meddelas via
            tjänstens startsida minst 30 dagar i förväg.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mt-8 mb-2">8. Tvist &amp; Lag</h2>
          <p>
            Svensk lag tillämpas. Tvist ska i första hand lösas genom förhandling. Om
            uppgörelse inte kan nås prövas tvisten av allmän domstol med Stockholms
            tingsrätt som första instans.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mt-8 mb-2">9. Kontakt</h2>
          <p>
            Frågor om villkoren? Mejla oss på
            <a href="mailto:info@bygglovkollen.se" className="text-blue-700 underline ml-1">info@bygglovkollen.se</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
